import { render, staticRenderFns } from "./HeaderMainMobileBasket.vue?vue&type=template&id=4a46b062&scoped=true&"
import script from "./HeaderMainMobileBasket.vue?vue&type=script&lang=js&"
export * from "./HeaderMainMobileBasket.vue?vue&type=script&lang=js&"
import style0 from "./HeaderMainMobileBasket.vue?vue&type=style&index=0&id=4a46b062&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a46b062",
  null
  
)

export default component.exports